import { connect } from "react-redux";
import { compose } from "recompose";
import { withMessenger } from "src/modules/messenger/Provider";
import { getCode } from "src/modules/device-discovery/duck/selectors";
import { isRequesting } from "src/modules/pairing-requester/duck/selectors";

import PairingResponder from "./PairingResponder";
import * as selectors from "../duck/selectors";
import { getFamilyName, getDeviceName } from "src/modules/auth/duck/selectors";
import { getPairedDevices } from "src/modules/device/duck/selectors/index";
import { isFreemium } from "src/modules/auth/duck/selectors";
import { getPresence } from "src/duck/selectors";

function mapStateToProps(state) {
  return {
    securityCode: getCode(state),
    isResponding: selectors.isResponding(state),
    error: selectors.getError(state),
    request: selectors.getRequest(state),
    isRequesting: isRequesting(state),
    familyName: getFamilyName(state),
    deviceName: getDeviceName(state),
    presence: getPresence(state),
    pairedDevices: getPairedDevices(state),
    isFreeVersion: isFreemium(state)
  };
}

const enhance = compose(connect(mapStateToProps), withMessenger);

export default enhance(PairingResponder);
